<svg
  [attr.fill]="fill()"
  height="100%"
  viewBox="0 0 48 48"
  width="100%"
  xmlns="http://www.w3.org/2000/svg">
  @switch (icon()) {
    @case (SvgIcon.Facebook) {
      <g>
        <g id="Layer_1">
          <path
            d="M17.9,48h9.7v-24.2h6.7l.7-8.1h-7.5v-4.6c0-1.9.4-2.7,2.2-2.7h5.2V0h-6.7c-7.2,0-10.4,3.2-10.4,9.2v6.5h-5v8.2h5v24.1Z" />
        </g>
      </g>
    }

    @case (SvgIcon.Google) {
      <g>
        <g id="Layer_1">
          <path
            d="M28.3,24.3c0,8.2-5.7,14.1-13.5,14.1S0,31.8,0,23.7s6.6-14.8,14.8-14.8,7.7,1.6,10.4,4.3l-3,2.6c-1.9-1.8-4.5-2.9-7.3-2.9-6,0-10.8,4.8-10.8,10.8s4.8,10.8,10.8,10.8,7.9-2.9,9-7.7h-9.3v-3.9s13.7,0,13.7,0v1.5ZM48,23h-5.7v-5.7h-3.6v5.7h-5.7v3.6h5.7v5.7h3.6v-5.7h5.7v-3.6Z" />
        </g>
      </g>
    }

    @case (SvgIcon.Instagram) {
      <g>
        <g id="Layer_1">
          <path
            d="M24,4.3c6.4,0,7.2,0,9.7.1,2.3.1,3.6.5,4.5.8,1.1.4,1.9,1,2.8,1.8.8.8,1.4,1.6,1.8,2.8.3.8.7,2.1.8,4.5.1,2.5.1,3.3.1,9.7s0,7.2-.1,9.7c-.1,2.3-.5,3.6-.8,4.5-.4,1.1-1,1.9-1.8,2.8s-1.6,1.4-2.8,1.8c-.8.3-2.1.7-4.5.8-2.5.1-3.3.1-9.7.1s-7.2,0-9.7-.1c-2.3-.1-3.6-.5-4.5-.8-1.1-.4-1.9-1-2.8-1.8-.8-.8-1.4-1.6-1.8-2.8-.3-.8-.7-2.1-.8-4.5-.1-2.5-.1-3.3-.1-9.7s0-7.2.1-9.7c.1-2.3.5-3.6.8-4.5.4-1.1,1-1.9,1.8-2.8.8-.8,1.6-1.4,2.8-1.8.8-.3,2.1-.7,4.5-.8,2.5-.1,3.3-.1,9.7-.1M24,0c-6.5,0-7.3,0-9.9.1-2.6.1-4.3.5-5.8,1.1-1.6.6-2.9,1.4-4.3,2.8-1.3,1.3-2.2,2.7-2.8,4.3-.6,1.5-1,3.3-1.1,5.8-.1,2.6-.1,3.4-.1,9.9s0,7.3.1,9.9c.1,2.6.5,4.3,1.1,5.8.6,1.6,1.4,2.9,2.8,4.3s2.7,2.2,4.3,2.8c1.5.6,3.3,1,5.8,1.1,2.6.1,3.4.1,9.9.1s7.3,0,9.9-.1c2.6-.1,4.3-.5,5.8-1.1,1.6-.6,2.9-1.4,4.3-2.8,1.3-1.3,2.2-2.7,2.8-4.3.6-1.5,1-3.3,1.1-5.8.1-2.6.1-3.4.1-9.9s0-7.3-.1-9.9c-.1-2.6-.5-4.3-1.1-5.8-.6-1.6-1.4-2.9-2.8-4.3-1.3-1.3-2.7-2.2-4.3-2.8-1.5-.6-3.3-1-5.8-1.1-2.6-.1-3.4-.1-9.9-.1M24,11.7c-6.8,0-12.3,5.5-12.3,12.3s5.5,12.3,12.3,12.3,12.3-5.5,12.3-12.3-5.5-12.3-12.3-12.3M24,32c-4.4,0-8-3.6-8-8s3.6-8,8-8,8,3.6,8,8-3.6,8-8,8M39.7,11.2c0-1.6-1.3-2.9-2.9-2.9s-2.9,1.3-2.9,2.9,1.3,2.9,2.9,2.9,2.9-1.3,2.9-2.9" />
        </g>
      </g>
    }

    @case (SvgIcon.Linkedin) {
      <g>
        <g id="Layer_1">
          <path
            d="M1,16h9.9v32H1v-32ZM5.9,11.8c3.2,0,5.9-2.6,5.9-5.9S9.1,0,5.9,0,0,2.6,0,5.9s2.6,5.9,5.9,5.9ZM26.7,31.2c0-4.5,2.1-7.2,6-7.2s5.4,2.6,5.4,7.2v16.8h9.9v-20.3c0-8.6-4.9-12.7-11.6-12.7s-9.6,5.3-9.6,5.3v-4.3h-9.5v32h9.5v-16.8Z" />
        </g>
      </g>
    }

    @case (SvgIcon.Pinterest) {
      <g>
        <g id="Layer_1">
          <path
            d="M10.8,27.8c.6.3,1.2,0,1.4-.7.1-.5.4-1.7.6-2.2.2-.7.1-.9-.4-1.5-1.1-1.3-1.8-3-1.8-5.4,0-7,5.2-13.2,13.6-13.2s11.5,4.5,11.5,10.6-3.5,14.7-8.7,14.7-5-2.4-4.4-5.3c.8-3.5,2.4-7.3,2.4-9.8s-1.2-4.1-3.7-4.1-5.3,3.1-5.3,7.1.9,4.4.9,4.4c0,0-3,12.8-3.5,15-1.1,4.5-.2,9.9,0,10.5,0,.3.5.4.7.2.3-.4,3.8-4.7,5-9,.3-1.2,1.9-7.6,1.9-7.6,1,1.8,3.8,3.4,6.7,3.4,8.9,0,14.9-8.1,14.9-18.9S35.4,0,24.9,0,5.2,9.4,5.2,17.2s1.8,9,5.6,10.5Z" />
        </g>
      </g>
    }

    @case (SvgIcon.TikTok) {
      <g>
        <g id="Layer_1">
          <path
            d="M44.9,11.7c0-.2,0-.2-.2-.2-.5,0-1.1,0-1.6-.1-1.9-.3-8.3-3.6-9.3-9,0-.1-.3-1.5-.3-2,0-.3,0-.3-.3-.3,0,0-.1,0-.2,0C30.5,0,28,0,25.5,0c-.5,0-.4,0-.4.4,0,10.7,0,21.5,0,32.2,0,.4,0,.8,0,1.2-.4,2.1-1.4,3.7-3.2,4.8-1.6,1-3.3,1.2-5,.9-.6-.1-1.1-.3-1.6-.5,0,0,0,0-.1-.1-.2-.1-.4-.3-.6-.4-2.3-1.6-3.4-3.8-3-6.5.3-2.8,1.9-4.7,4.6-5.7.8-.3,1.6-.4,2.5-.4.5,0,1.1,0,1.6.2.2,0,.3,0,.3-.2,0,0,0-.1,0-.2,0-1.9,0-6.1,0-6.1,0-.6,0-1.1,0-1.7,0-.2,0-.2-.2-.2-1-.1-2-.1-3,0-1.4.1-2.7.4-4,.9-2.1.7-3.9,1.9-5.5,3.5-1.4,1.3-2.4,2.9-3.2,4.6-.7,1.7-1.2,3.4-1.3,5.2,0,.8,0,1.6,0,2.4.1,1.1.3,2.2.6,3.2,1,3,2.7,5.4,5.1,7.4.2.2.5.4.8.5,0,0,0,0,0,0,.1.1.3.2.4.3.4.3.8.6,1.3.8,2.7,1.4,5.6,1.9,8.7,1.5,4-.5,7.3-2.2,9.9-5.3,2.4-2.8,3.6-6.2,3.7-9.9,0-5.3,0-10.7,0-16,0-.1,0-.3,0-.4.1,0,.2,0,.3.2,2,1.3,4.1,2.3,6.5,2.8,1.4.3,2.7.5,4.1.5.4,0,.5,0,.5-.5,0-1.9,0-7.1,0-7.6Z" />
        </g>
      </g>
    }

    @case (SvgIcon.Web) {
      <g>
        <g id="Layer_1">
          <path
            d="M22.7,48h2.3c12.9-.5,23-11.1,23-24S37.9.5,25,0h-2.3s0,0,0,0C10,.7,0,11.2,0,24s10,23.3,22.7,24ZM8.2,39.5c1.5-1.1,3.2-2.1,4.9-2.8,1.7,3.5,3.9,6.5,6.8,9.1-4.4-.8-8.6-3-11.7-6.3ZM23.1,45.9c-3.5-2.6-6.3-6.1-8.2-9.9,2.6-1,5.4-1.5,8.2-1.6v11.6ZM23.1,32.5c-3.1.1-6.1.7-9,1.8-1.1-2.7-1.7-5.6-1.9-8.6h10.9s0,6.8,0,6.8ZM23.1,23.9h-10.9c0-3,.5-6,1.5-8.9,3,1.2,6.2,1.9,9.4,2v6.9ZM27.7,45.9c3-2.7,5.4-5.9,7.1-9.5,1.9.8,3.6,1.7,5.3,2.9-3.3,3.5-7.6,5.8-12.3,6.6ZM41.3,37.8c-1.8-1.3-3.7-2.3-5.8-3.2,1.1-2.8,1.7-5.9,1.9-9h8.7c-.3,4.5-2,8.6-4.8,12.1ZM42,11.1c2.7,3.7,4.1,8.1,4.2,12.8h-8.7c0-3.2-.5-6.3-1.5-9.2,2.1-.9,4.2-2.1,6-3.5ZM40.8,9.6c-1.7,1.3-3.6,2.4-5.5,3.2-1.7-4.1-4.3-7.7-7.6-10.7,5.1.9,9.7,3.5,13.1,7.5ZM24.9,2.3c3.9,3,6.8,6.9,8.7,11.3-2.8,1-5.7,1.5-8.7,1.6V2.3ZM24.9,17c3.2,0,6.3-.6,9.3-1.7.9,2.8,1.4,5.6,1.4,8.6h-10.7s0-6.8,0-6.8ZM24.9,25.7h10.6c-.2,2.9-.8,5.7-1.8,8.3-2.8-.9-5.8-1.5-8.8-1.5v-6.8ZM24.9,34.4c2.8,0,5.5.5,8.1,1.4-1.8,3.9-4.6,7.3-8.1,10v-11.4ZM23.1,2.1v13.1c-3-.1-6-.8-8.8-1.9,1.9-4.4,4.9-8.2,8.8-11.2ZM20,2.2c-3.2,2.9-5.7,6.4-7.4,10.3-1.8-.9-3.6-1.9-5.1-3.2,3.3-3.7,7.7-6.2,12.5-7.1ZM6.3,10.7c1.8,1.4,3.6,2.6,5.6,3.5-1.1,3.1-1.6,6.3-1.6,9.6H1.9c0-4.8,1.6-9.3,4.4-13.1ZM1.9,25.7h8.4c.2,3.2.9,6.3,2.1,9.3-1.9.9-3.7,1.9-5.4,3.1-3-3.6-4.7-7.8-5-12.4Z" />
        </g>
      </g>
    }

    @case (SvgIcon.Youtube) {
      <g>
        <g id="Layer_1">
          <path
            d="M47,13.3c-.6-2.1-2.2-3.7-4.2-4.3-3.7-1-18.8-1-18.8-1,0,0-15,0-18.8,1-2.1.6-3.7,2.2-4.2,4.3-1,3.8-1,11.6-1,11.6,0,0,0,7.9,1,11.6.6,2.1,2.2,3.7,4.2,4.3,3.7,1,18.8,1,18.8,1,0,0,15,0,18.8-1,2.1-.6,3.7-2.2,4.2-4.3,1-3.8,1-11.6,1-11.6,0,0,0-7.9-1-11.6ZM19.1,32v-14.3l12.5,7.1-12.5,7.1Z" />
        </g>
      </g>
    }

    @case (SvgIcon.Basket) {
      <g>
        <g id="Layer_1">
          <path
            d="M45.5,47.4s0,0,0-.1,0,0,0-.2c0,0,0,0,0-.2,0,0,0-.1,0-.2v-.3h0c0-.2,0-.1,0-.2h0s-2-32.6-2-32.6h0v-.3s0-.1,0-.2c0,0,0-.1,0-.2,0,0,0-.1,0-.2,0,0,0,0,0-.1,0,0,0,0-.1-.2,0,0,0,0,0-.1,0,0,0,0-.2-.1,0,0,0,0-.1,0,0,0-.1,0-.2,0s0,0-.1,0-.1,0-.2,0h-6.9v-2.4c0-5.4-4.4-9.8-9.8-9.8h-4.1c-5.4,0-9.8,4.4-9.8,9.8v2.4h-6.9c0,0-.1,0-.2,0,0,0,0,0-.1,0,0,0-.1,0-.2,0,0,0,0,0-.1,0,0,0,0,0-.1.1,0,0,0,0-.1.1,0,0,0,0-.1.1,0,0,0,0,0,.1,0,0,0,0,0,.2,0,0,0,.1,0,.2s0,.1,0,.2v.2h0c0,.1-2.1,32.7-2.1,32.7h0v.5s0,.1,0,.2c0,0,0,.1,0,.2,0,0,0,0,0,.2,0,0,0,0,0,.1s0,0,.1.1c0,0,0,0,.1.1,0,0,0,0,.1.1,0,0,0,0,.1,0,0,0,0,0,.2,0,0,0,.1,0,.2,0s.1,0,.2,0h41.5s.1,0,.2,0c0,0,.1,0,.2,0,0,0,0,0,.2,0,0,0,0,0,.1,0,0,0,0,0,.1-.1,0,0,0,0,.1-.1h.1c0-.1,0-.1,0-.1ZM15.4,9.8c0-3.5,2.8-6.4,6.4-6.4h4.1c3.5,0,6.4,2.9,6.4,6.4v2.4H15.4v-2.4h0ZM13.6,19.6c.9,0,1.7-.8,1.7-1.7v-2.4h16.9v2.4c0,.9.8,1.7,1.7,1.7s1.7-.8,1.7-1.7v-2.4h4.8l1.8,29.1H5.3l1.8-29.1h4.8v2.4c0,.9.8,1.7,1.7,1.7h0Z" />
        </g>
      </g>
    }

    @case (SvgIcon.Account) {
      <g>
        <g id="Layer_1">
          <path
            d="M32.3,24.9c-.1,0-.3,0-.4,0,3.4-2.5,5.6-6.5,5.6-11.1,0-7.6-6.2-13.8-13.8-13.8s-13.8,6.2-13.8,13.8,2.2,8.5,5.6,11c0,0-.2,0-.2,0-7.8,2-13.5,9-13.5,17.4v4.1c0,.9.8,1.7,1.7,1.7h40.5c.9,0,1.7-.8,1.7-1.7v-4.1c0-8.3-5.7-15.3-13.4-17.3ZM13.2,13.8c0-5.8,4.7-10.6,10.6-10.6s10.6,4.7,10.6,10.6-4.7,10.6-10.6,10.6-10.6-4.7-10.6-10.6ZM42.3,44.6H5.2v-2.4c0-8,6.5-14.5,14.5-14.5h8.1c8,0,14.5,6.5,14.5,14.5v2.4Z" />
        </g>
      </g>
    }
  }
</svg>
